import { defineMessages } from 'react-intl';

export const messages: {
	statusPageSpotlightNavigationHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	statusPageSpotlightNavigationBody: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	statusPageSpotlightNavigationAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	statusPageSpotlightNavigationHeading: {
		defaultMessage: 'Create and manage status pages',
		description: 'Heading for the Statuspage navigation spotlight',
		id: 'statuspage.navigation-spotlight.heading',
	},
	statusPageSpotlightNavigationBody: {
		defaultMessage:
			'Post real-time updates and customize your status pages directly from here, without switching platforms.',
		description: 'Body text for the Statuspage navigation spotlight',
		id: 'statuspage.navigation-spotlight.body',
	},
	statusPageSpotlightNavigationAction: {
		defaultMessage: 'About status pages',
		description: 'Primary action button for the Statuspage navigation spotlight',
		id: 'statuspage.navigation-spotlight.action',
	},
});
